import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65ce95e1de35/components/forms/DemoForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Section.module.css");
